module.exports = __webpack_public_path__ + "img/5.7f20b921.png";